import React from 'react';
import FeatureBox from './FeatureBox';

const FeatureShowcase = () => {
  const features = [
        {
      icon: "Brain",
      title: "Learning Intelligence",
      description: "An AI-guided curriculum that adapts to how you learn, built around the skills employers and institutions actually value.",
      color: "accent"
    },
    {
      icon: "Award",
      title: "Verified Achievement",
      description: "Every badge and certificate reflects real, demonstrated progress, recognized by the institutions and employers who matter.",
      color: "success"
    },
    {
      icon: "TrendingUp",
      title: "Actionable Insights",
      description: "Clear, data-driven analytics show exactly where you stand and what to master next, no guesswork.",
      color: "primary"
    },
    {
      icon: "Shield",
      title: "Blockchain-Verified Credentials",
      description: "Your credentials are secured on-chain, instantly verifiable and portable, proof that can never be faked or lost.",
      color: "warning"
    }
  ];

  return (
        <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tighter text-black mb-4">
            A Learning Intelligence Platform
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Built for learners who want proof that lasts, and institutions that need credentials they can trust and verify.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features?.map((feature, index) => (
            <FeatureBox
              key={index}
              icon={feature?.icon}
              title={feature?.title}
              description={feature?.description}
              color={feature?.color}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureShowcase;